import { notification } from 'antd';
import Fetch from 'jsx/common/util/_fetch';
import AutomationForm from 'jsx/configuration/components/AutomationForm';
import {
  recursiveCleanup,
  cleanActions,
  preTriggerStoreCleanup,
  preConditionsStoreCleanup,
} from 'jsx/configuration/util/cleanup';
import {
  PageContent,
  openNotificationWithIcon,
  ApiAutomation,
} from '@mss/mss-component-library';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FormValuesContext } from '../../../contexts/FormValuesContext';

function AddAutomation() {
  const [t] = useTranslation(['configuration', 'common']);
  const history = useHistory();
  const [customReceivers] = useContext(FormValuesContext);

  const handleSubmit = async (val: ApiAutomation) => {
    const values =
      customReceivers?.value === ''
        ? { ...val }
        : {
            ...val,
            actions: val.actions.map((action, i) =>
              i === customReceivers?.index
                ? {
                    ...action,
                    settings: {
                      ...action.settings,
                      custom_email: customReceivers?.value,
                    },
                  }
                : action
            ),
          };

    const conditionsParsedValues = {
      ...values,
      conditions: { operator: 'AND', conditions: values.conditions },
    };
    conditionsParsedValues.actions = cleanActions(
      conditionsParsedValues.actions
    );
    recursiveCleanup(conditionsParsedValues.actions);
    recursiveCleanup(conditionsParsedValues.conditions);

    /*
    Lets create a copy and cleanup new object for posting so no reference to
    the original object exists.
     */
    const newItem = JSON.parse(JSON.stringify(conditionsParsedValues));
    preTriggerStoreCleanup(newItem.trigger);
    preConditionsStoreCleanup(newItem.conditions);

    try {
      const resp = await Fetch.post(`/api/automation/`, {
        body: JSON.stringify(newItem),
      });

      if (resp.status === 201) {
        openNotificationWithIcon(
          notification.success,
          t('Automation successfully created'),
          ''
        );

        history.push('/configuration/automations');
      } else {
        let message = '';
        try {
          const json = await resp.json();
          message = json.message || message;
        } catch {}
        throw new Error(message);
      }
    } catch (e: any) {
      console.error({ e });
      openNotificationWithIcon(
        notification.error,
        t('Automation not saved'),
        <small>{e.message}</small>
      );
    }
  };

  return (
    <PageContent title={t('Add automation')}>
      <AutomationForm disabled={''} handleSubmit={handleSubmit} />
    </PageContent>
  );
}

export default AddAutomation;
